export const STATES = {
	IDLE: 'IDLE',
	LOADING: 'LOADING',
	LOADED: 'LOADED',
	FAILED: 'FAILED'
};
